import React from 'react'
import { useContext } from 'react'
import AuthContext from './AuthContext';

const Logout = ({handlelogin}) => {
    const {setisLoggedIn} = useContext(AuthContext);    
    const {settoken} = useContext(AuthContext);    
    handlelogin("login");
    setisLoggedIn((a) => (false)); 
    settoken('');
              
  return (
    <div>คุณได้ออกจากระบบเรียบร้อยแล้วครับ</div>
  )
}

export default Logout